/* eslint-disable */
import React, { useEffect } from "react";
import { Nav, Collapse, Image } from "react-bootstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  CATEGORY_URL,
  DASHBOARD_URL,
  FBA_ORDER_LIST,
  REFURBISHED_REPORT_LIST,
  TICKETS_URL,
  ERP_API_FAILURES_LIST,
  ADD_RESALE_BRANDS_URL,
  RESALE_BRANDS_URL,
  ADD_AGE_VALUE_REPORT,
  PRODUCT_APPLICATIONS_URL,
  AGE_VALUE_REPORT,
  UPDATE_RESALE_BRANDS_URL,
  ADD_POINT_VALUE_SETTINGS,
  POINT_VALUE_REFURBISHED_REPORT,
  SETTINGS_REFURBISHED_REPORT,
  SUB_CATEGORY_URL,
  PRODUCT_CREATION_URL,
  SPARES_CAMPATIBILITY_URL,
  RETURN_AND_REPLACE_REPORT,
  ADD_POINT_VALUE_REFURBISHED_REPORT,
  EDIT_POINT_VALUE_REFURBISHED_REPORT,
  CREATE_PRODUCT_APLICATION_URL,
  RETURN_AND_REPLACE_REPORT_LIST,
  STORE_INWARD_LOG_URL,
  ERP_OUTSTANDING_REPORT,
  CREATE_CATEGORY_URL,
  CREATE_SUB_CATEGORY_URL,
  CREATE_PRODUCT_URL,
  RM_LOGIN_URL,
  FRANCHISE_USER_REPORT_URL,
  CREATE_FRANCHISE_USER_REPORT_URL,
  STOCK_INWARD_URL,
  STOCK_LEVEL_URL,
  STORE_DETAILS_URL,
  STORE_DETAILS_REPORT_URL,
  FRANCHISE_REPORT_DETAILS_URL,
  STOCK_TRANSFER_URL,
  WAREHOUSE_URL,
  CREATE_WAREHOUSE_URL,
  WAREHOUSE_QUICK_URL,
  FRANCHISE_ORDERSREPORT_URL,
  E_WAY_BILL_URL,
  FRANCHISE_STOCK_LEVEL_URL,
  E_INVOICE_CANCEL_URL,
  E_INVOICE_DETAILS_URL,
  PUR_INVOICE_DETAILS_URL,
  PUR_ORDER_DELIVERED_URL,
  FRANCHISE_PENDING_DELIVERY_URL,
  FRANCHISE_DISPATCH_PENDING_URL,
  FRANCHISE_DISPATCH_URL,
  FRANCHISE_PENDING_ORDERS_URL,
  PO_APPROVALS_URL,
  PO_POSTING_URL,
  USER_MANAGEMENT_URL,
  REGION_MASTER_URL,
  ADD_REGION_MASTER_URL,
  CITIES_URL,
  STATES_URL,
  ADD_CITIES_URL,
  ADD_STATES_URL,
  PINE_CODES_URL,
  CREATE_USER_MANAGEMENT_URL,
  FRANCHISE_TYPE_REPORT_URL,
  ADD_FRANCHISE_TYPE_REPORT_URL,
  PRODUCT_GROUP_URL,
  CREATE_PRODUCT_GROUP_URL,
  PURCHASE_ORDER_URL,
  DISPATCH_LIST_URL,
  CREATE_DISPATCH_LIST_URL,
  COURIERS_URL,
  ORDER_CANCELLED_URL,
  BOX_URL,
  DEBIT_CREDIT_NOTES,
  ACCOUNT_LEDGER_REPORT,
  GSTDATAREPORT,
  GST_DATA_REPORT,
  OUT_STANDING_DATA_REPORT,
  DEBIT_CREDIT_NOTE_REPORT,
  DEPOSIT_REPORT,
  PAYMENT_APPROVAL,
  CREDIT_NOTE_REQUEST,
  CREDIT_NOTE_REPORT,
  PURCHASE_LIST_URL,
  ADD_PINCODES_URL,
  FRANCHISE_USER_REPORT_BRAND,
  FBA_ORDER_DETAILS_LIST,
  RE_ASSIGN_WAREHOUSE_LIST,
  SALES_PERSON_PERFORMANCE_URL,
  INCENTIVE_SLAB_URL,
  ADD_INCENTIVE_SLAB_URL,
  ERP_GENERAL_OUTSTANDING_REPORT,
  AFTER_SALES_ORDERS_URL,
  SCHEMES_URL,
  ADD_SCHEMES_URL,
  UNICOMMERCE_API_FAILURES_REPORT,
  ADD_SALES_PERSON_PERFORMANCE_URL,
  ADD_SPARES_CAMPATIBILITY_URL,
  PURCHASE_LOG_LIST_URL,
  HELP_DESK_CATEGORY,
  ADD_HELP_DESK_CATEGORY,
  EDIT_HELP_DESK_CATEGORY,
  HELP_DESK_SUB_CATEGORY,
  ADD_HELP_DESK_SUB_CATEGORY,
  HELP_DESK_FAQ,
  ADD_HELP_DESK_FAQ,
  DASHBOARD_SALES_REVENUE_REPORT_URL,
  DASHBOARD_TRANSACTION_HISTORY_URL,
  DASHBOARD_SCHEMES_METRICS_URL,
  DASHBOARD_WARRANTY_REGISTRATION_URL,
  AFS_PURCHASE_ORDER_URL,
  QUOTATION_CREATIONS_URL,
  QUOTATION_REPORT_URL,
  PAYMENT_APPROVAL_URL,
  AFS_ORDER_SYNC_REPORT_URL,
  PAYMENT_APPROVAL_PENDING_QUOTATION_URL,
  NOTIFICATION_AND_CMS_URL,
  MARKETING_CAMPAIGNS_URL,
  FRANCHISE_REPORTS_URL,
  ERP_STOCK_LEVEL_URL,
  ERP_STOCK_REPORT_URL,
  UPCOMING_ORDER_URL,
  ERP_STOCK_LOGS_URL,
  ALL_MAIL_LISTING_URL,
  ORDER_PAYMENT_APPROVAL_PENDING,
  FRANCHISE_DRAFT_ORDERSREPORT_URL,
  OFFER_SCHEME_URL,
  D2C_DASHBOARD_URL,
} from "../constant";
import { hasD2cOpsAccess } from "../../Franchise/D2CDashboard/d2cAccess";
import { useSelector, useDispatch } from "react-redux";
import {
  SearchPincodeList,
  SearchCommonPincodeList,
  getSearchModulesObjects,
  getPointValueList,
  getResallBrandList,
  getResellcycleReportsList,
  getResellcycleCustomerReportsList,
  ErrorMessageFromRedux,
  GetReturnReplaceInvoiceOrderDetails,
  GetReturnReplaceFramesOrderDetails,
  errorCreateSparesCampatibilityList,
  GetafterSalesOrdersDetails,
  TicketsVerfiyAPI,
  getGSTReportList,
  getAllAfterSalesOrderList,
  getAfterSalesOrdersList,
  getAFSPendingDispatchOrdersList,
  getAFSPendingDeliveryOrdersList,
  getAFSDeliveredOrdersList,
  getAFSCancelledOrdersList,
  getAFSReturnedOrdersList,
  getAFSDraftOrdersList,
  GetAllDealerFranchiseUserTypeList,
  getAllWareHouseList,
  GetAllFranchiseTypeList,
  getAllCategoryList,
  getAllSubCategoryList,
  getAllSparesCampatibilityList,
  getBundleItemAllList,
  getAllProductList,
  getAllCityList,
  getAllStateList,
  getAllUserList,
  getUserDetails,
  getErpAcountListSOrder,
  GetOrderReportDetails,
} from "../../../redux/actions/adminActions";
import MenuArrow from "../../../assets/img/MenuArrow.png";
import CommonScrollBar from "../../Common/CommonScrollBar";
import { confirmLeave } from "../../Warranty/common/unsavedGuard";
import { visibleWarrantyNav, isWarrantySegment } from "../../Warranty/common/warrantyNav";

const SidebarChild = (props) => {
  const { selfInfo, MainNavUrl } = useSelector((state) => state.adminReducers);
  const { menuStates, setMenuStates } = props;
  const Dispatch = useDispatch();
  const LocationURL = useLocation().pathname;
  const LocationEditURL = LocationURL?.split("/")[1];
  const PermissionsAccess = selfInfo?.user?.permissions_access;

  // toggle menu
  const toggleMenu = (menu) => {
    const updatedMenuStates = { ...menuStates };
    Object.keys(updatedMenuStates).forEach((key) => {
      if (key === menu) {
        updatedMenuStates[key] = !updatedMenuStates[key];
      } else {
        updatedMenuStates[key] = false;
      }
    });
    setMenuStates(updatedMenuStates);
  };

  // Update Toggle
  useEffect(() => {
    if (MainNavUrl === "Inventory") {
      if (
        LocationURL === PRODUCT_APPLICATIONS_URL ||
        LocationURL === CATEGORY_URL ||
        LocationURL === SUB_CATEGORY_URL ||
        LocationURL === PRODUCT_CREATION_URL ||
        LocationURL === CREATE_PRODUCT_APLICATION_URL ||
        LocationURL === CREATE_CATEGORY_URL ||
        LocationURL === CREATE_SUB_CATEGORY_URL ||
        LocationURL === CREATE_PRODUCT_URL ||
        LocationURL === FRANCHISE_USER_REPORT_URL ||
        LocationEditURL === "edit-product-application" ||
        LocationEditURL === "edit-category" ||
        LocationEditURL === "edit-subcategory" ||
        LocationEditURL === "edit-product" ||
        LocationURL === PRODUCT_GROUP_URL ||
        LocationURL === SPARES_CAMPATIBILITY_URL ||
        LocationURL === ADD_SPARES_CAMPATIBILITY_URL ||
        LocationEditURL === "edit-spares-compatibility"
      ) {
        setMenuStates({
          ...menuStates,
          menu1: true,
          menu2: false,
          menu3: false,
          menu4: false,
        });
      } else if (
        LocationURL === STOCK_INWARD_URL ||
        LocationURL === STOCK_LEVEL_URL ||
        LocationURL === STORE_DETAILS_URL ||
        LocationURL === STORE_DETAILS_REPORT_URL ||
        LocationURL === FRANCHISE_REPORT_DETAILS_URL ||
        LocationURL === STORE_INWARD_LOG_URL ||
        LocationURL === ERP_STOCK_LEVEL_URL ||
        LocationURL === ERP_STOCK_REPORT_URL ||
        LocationURL === ERP_STOCK_LOGS_URL
      ) {
        setMenuStates({
          ...menuStates,
          menu1: false,
          menu2: true,
          menu3: false,
          menu4: false,
        });
      } else if (LocationURL === STOCK_TRANSFER_URL) {
        setMenuStates({
          ...menuStates,
          menu1: false,
          menu2: false,
          menu3: true,
          menu4: false,
        });
      } else if (
        LocationURL === WAREHOUSE_URL ||
        LocationURL === CREATE_WAREHOUSE_URL ||
        LocationEditURL === "edit-warehouse" ||
        LocationURL === WAREHOUSE_QUICK_URL ||
        LocationURL === DISPATCH_LIST_URL ||
        LocationURL === CREATE_DISPATCH_LIST_URL ||
        LocationEditURL === "edit-dispatch"
      ) {
        setMenuStates({
          ...menuStates,
          menu1: false,
          menu2: false,
          menu3: false,
          menu4: true,
        });
      }
    } else if (MainNavUrl === "Admin-Tools") {
      if (
        LocationURL === USER_MANAGEMENT_URL ||
        LocationURL === CREATE_USER_MANAGEMENT_URL ||
        LocationEditURL === "edit-user" ||
        LocationURL === FRANCHISE_USER_REPORT_URL ||
        LocationURL === CREATE_FRANCHISE_USER_REPORT_URL ||
        LocationEditURL === "edit-franchise-user-report" ||
        LocationURL === FRANCHISE_TYPE_REPORT_URL ||
        LocationURL === ADD_FRANCHISE_TYPE_REPORT_URL ||
        LocationEditURL === "edit-franchise-type-report" ||
        LocationURL === RM_LOGIN_URL ||
        LocationURL === FRANCHISE_USER_REPORT_BRAND
      ) {
        setMenuStates({
          ...menuStates,
          menu1: true,
          menu2: false,
        });
      } else if (
        LocationURL === CITIES_URL ||
        LocationURL === STATES_URL ||
        LocationURL === ADD_CITIES_URL ||
        LocationEditURL === "edit-cities" ||
        LocationURL === ADD_STATES_URL ||
        LocationURL === PINE_CODES_URL ||
        LocationURL === ADD_PINCODES_URL ||
        LocationEditURL === "edit-pincode" ||
        LocationURL === BOX_URL ||
        LocationURL === COURIERS_URL
      ) {
        setMenuStates({
          ...menuStates,
          menu1: false,
          menu2: true,
        });
      }
    } else if (MainNavUrl === "Franchise") {
      if (
        LocationURL === FRANCHISE_ORDERSREPORT_URL ||
        LocationURL === FRANCHISE_DRAFT_ORDERSREPORT_URL ||
        LocationURL === E_WAY_BILL_URL ||
        LocationURL === FRANCHISE_STOCK_LEVEL_URL ||
        LocationURL === E_INVOICE_CANCEL_URL ||
        LocationURL === E_INVOICE_DETAILS_URL ||
        LocationURL === PUR_INVOICE_DETAILS_URL ||
        LocationURL === PUR_ORDER_DELIVERED_URL ||
        LocationURL === D2C_DASHBOARD_URL ||
        LocationURL === FRANCHISE_PENDING_DELIVERY_URL ||
        LocationEditURL === "pending-for-delivery" ||
        LocationURL === FRANCHISE_DISPATCH_PENDING_URL ||
        LocationEditURL === "pending-for-dispatch" ||
        LocationURL === FRANCHISE_DISPATCH_URL ||
        LocationURL === FRANCHISE_PENDING_ORDERS_URL ||
        LocationURL === PO_APPROVALS_URL ||
        LocationURL === PO_POSTING_URL ||
        LocationURL === PURCHASE_ORDER_URL ||
        LocationEditURL === "so-approval" ||
        LocationEditURL === "warehouse-approvals" ||
        LocationEditURL === "pending-for-stores" ||
        LocationURL === ORDER_CANCELLED_URL ||
        LocationURL === E_INVOICE_DETAILS_URL ||
        LocationURL === E_INVOICE_CANCEL_URL ||
        LocationURL === E_WAY_BILL_URL ||
        LocationURL === RETURN_AND_REPLACE_REPORT ||
        LocationURL === RETURN_AND_REPLACE_REPORT_LIST ||
        LocationURL === ERP_API_FAILURES_LIST ||
        LocationURL === UNICOMMERCE_API_FAILURES_REPORT ||
        LocationURL === FBA_ORDER_LIST ||
        LocationEditURL === "fba-orders-details" ||
        LocationURL === RE_ASSIGN_WAREHOUSE_LIST ||
        LocationURL === UPCOMING_ORDER_URL
      ) {
        setMenuStates({
          ...menuStates,
          menu1: true,
          menu2: false,
          menu3: false,
        });
      } else if (
        LocationURL === DEBIT_CREDIT_NOTES ||
        LocationURL === ACCOUNT_LEDGER_REPORT ||
        LocationURL === DEBIT_CREDIT_NOTE_REPORT ||
        LocationURL === DEPOSIT_REPORT ||
        LocationURL === PAYMENT_APPROVAL ||
        LocationURL === CREDIT_NOTE_REQUEST ||
        LocationURL === CREDIT_NOTE_REPORT ||
        LocationEditURL === DEBIT_CREDIT_NOTES ||
        LocationURL === GST_DATA_REPORT ||
        LocationURL === ERP_OUTSTANDING_REPORT ||
        LocationURL === ERP_GENERAL_OUTSTANDING_REPORT ||
        LocationURL === PAYMENT_APPROVAL_URL ||
        LocationURL === FRANCHISE_REPORTS_URL ||
        LocationURL === ORDER_PAYMENT_APPROVAL_PENDING
      ) {
        setMenuStates({
          ...menuStates,
          menu1: false,
          menu2: true,
          menu3: false,
        });
      } else if (
        LocationURL === AFTER_SALES_ORDERS_URL ||
        LocationEditURL === "after-sales-orders" ||
        LocationURL === AFS_PURCHASE_ORDER_URL ||
        LocationURL === QUOTATION_CREATIONS_URL ||
        LocationURL === QUOTATION_REPORT_URL ||
        LocationEditURL === "quotation-details" ||
        LocationURL === AFS_ORDER_SYNC_REPORT_URL ||
        LocationURL === PAYMENT_APPROVAL_PENDING_QUOTATION_URL ||
        LocationEditURL === "payment-approval-quotation-details"
      ) {
        setMenuStates({
          ...menuStates,
          menu1: false,
          menu2: false,
          menu3: true,
        });
      }
    } else if (MainNavUrl === "CRM-Tools") {
      if (
        LocationURL === REGION_MASTER_URL ||
        LocationURL === ADD_REGION_MASTER_URL ||
        LocationEditURL === "edit-region-master" ||
        LocationURL === PURCHASE_LIST_URL ||
        LocationEditURL === "edit-purchase" ||
        LocationURL === SALES_PERSON_PERFORMANCE_URL ||
        LocationURL === ADD_SALES_PERSON_PERFORMANCE_URL ||
        LocationURL === PURCHASE_LOG_LIST_URL ||
        LocationURL === ALL_MAIL_LISTING_URL ||
        LocationEditURL === "update-mails" ||
        LocationEditURL === "create-mails"
      ) {
        setMenuStates({
          ...menuStates,
          menu1: true,
          menu2: false,
          menu3: false,
        });
      } else if (
        LocationURL === SETTINGS_REFURBISHED_REPORT ||
        LocationURL === POINT_VALUE_REFURBISHED_REPORT ||
        LocationURL === ADD_POINT_VALUE_REFURBISHED_REPORT ||
        LocationEditURL === "edit-point" ||
        LocationURL === REFURBISHED_REPORT_LIST ||
        LocationURL === ADD_POINT_VALUE_SETTINGS ||
        LocationEditURL === "edit-point-settings" ||
        LocationURL === AGE_VALUE_REPORT ||
        LocationURL === ADD_AGE_VALUE_REPORT ||
        LocationEditURL === "edit-age-value" ||
        LocationURL === RESALE_BRANDS_URL ||
        LocationURL === ADD_RESALE_BRANDS_URL ||
        LocationEditURL === "edit-resale-brand"
      ) {
        setMenuStates({
          ...menuStates,
          menu1: false,
          menu2: true,
          menu3: false,
        });
      } else if (
        LocationURL === SCHEMES_URL ||
        LocationURL === ADD_SCHEMES_URL ||
        LocationEditURL === "edit-schemes" ||
        LocationURL === INCENTIVE_SLAB_URL ||
        LocationURL === ADD_INCENTIVE_SLAB_URL ||
        LocationEditURL === "edit-incentive-slab" ||
        LocationURL === TICKETS_URL ||
        LocationURL === HELP_DESK_CATEGORY ||
        LocationURL === ADD_HELP_DESK_CATEGORY ||
        LocationEditURL === "edit-help-desk-category" ||
        LocationURL === HELP_DESK_SUB_CATEGORY ||
        LocationURL === ADD_HELP_DESK_SUB_CATEGORY ||
        LocationEditURL === "edit-help-desk-sub-category" ||
        LocationURL === HELP_DESK_FAQ ||
        LocationURL === ADD_HELP_DESK_FAQ ||
        LocationEditURL === "edit-help-desk-faq" ||
        LocationURL === NOTIFICATION_AND_CMS_URL ||
        LocationEditURL === "create-notifications-and-cms" ||
        LocationEditURL === "edit-notifications-and-cms" ||
        LocationURL === MARKETING_CAMPAIGNS_URL ||
        LocationEditURL === "create-marketing-campaigns" ||
        LocationEditURL === "edit-marketing-campaigns" ||
        LocationURL === OFFER_SCHEME_URL ||  
        LocationEditURL === "create-offer-scheme" ||
        LocationEditURL === "edit-offer-scheme"
      ) {
        setMenuStates({
          ...menuStates,
          menu1: false,
          menu2: false,
          menu3: true,
        });
      }
    } else if (MainNavUrl === "Sales") {
      if (LocationURL === OUT_STANDING_DATA_REPORT) {
        setMenuStates({
          ...menuStates,
          menu3: true,
        });
      }
    } else if (MainNavUrl === "Warranty") {
      if (
        isWarrantySegment(LocationEditURL) ||
        LocationURL === DASHBOARD_WARRANTY_REGISTRATION_URL
      ) {
        setMenuStates({
          ...menuStates,
          menu6: true,
        });
      }
    } else if (MainNavUrl === "Dashboard") {
      if (
        LocationURL === DASHBOARD_URL ||
        LocationURL === DASHBOARD_SALES_REVENUE_REPORT_URL ||
        LocationURL === DASHBOARD_TRANSACTION_HISTORY_URL ||
        LocationURL === DASHBOARD_SCHEMES_METRICS_URL ||
        LocationURL === DASHBOARD_WARRANTY_REGISTRATION_URL ||
        LocationEditURL === "schemes-metrics"
      ) {
        setMenuStates({
          ...menuStates,
          menu1: false,
          menu2: false,
          menu3: false,
          menu4: false,
          menu5: true,
        });
      }
    }
  }, [MainNavUrl, LocationURL]);

  // common navigations links
  const CommonNavigationsChange = (e) => {
    if (e?.target?.className !== "active") {
      Dispatch(getSearchModulesObjects(""));
      Dispatch(errorCreateSparesCampatibilityList([]));
      Dispatch(GetafterSalesOrdersDetails({}));
      Dispatch(TicketsVerfiyAPI({}));
      Dispatch(getGSTReportList({}));
      Dispatch(getAllAfterSalesOrderList({}));
      Dispatch(getAfterSalesOrdersList({}));
      Dispatch(getAFSPendingDispatchOrdersList({}));
      Dispatch(getAFSPendingDeliveryOrdersList({}));
      Dispatch(getAFSDeliveredOrdersList({}));
      Dispatch(getAFSCancelledOrdersList({}));
      Dispatch(getAFSReturnedOrdersList({}));
      Dispatch(getAFSDraftOrdersList({}));
      Dispatch(GetAllDealerFranchiseUserTypeList({}));
      Dispatch(getAllWareHouseList([]));
      Dispatch(GetAllFranchiseTypeList([]));
      Dispatch(getAllCategoryList([]));
      Dispatch(getAllSubCategoryList([]));
      Dispatch(getAllSparesCampatibilityList([]));
      Dispatch(getBundleItemAllList({}));
      Dispatch(getAllProductList([]));
      Dispatch(getAllCityList([]));
      Dispatch(getAllStateList([]));
      Dispatch(getAllUserList([]));
      Dispatch(getErpAcountListSOrder({}));
      Dispatch(GetOrderReportDetails({}));
    } else {
      Dispatch(GetOrderReportDetails({}));
    }
  };

  // Warranty links: the draft editor can hold unsaved changes, and BrowserRouter has no blocker,
  // so these links ask first. Other menus are not guarded.
  const WarrantyLinkClick = (e) => {
    if (!confirmLeave()) {
      e.preventDefault();
      return;
    }
    CommonNavigationsChange(e);
  };

  useEffect(() => {
    return () => {
      Dispatch(getErpAcountListSOrder({}));
      Dispatch(SearchPincodeList({}));
      Dispatch(SearchCommonPincodeList({}));
      Dispatch(
        ErrorMessageFromRedux({
          API: "",
          Error: "",
        })
      );
      Dispatch(GetReturnReplaceInvoiceOrderDetails([]));
      Dispatch(GetReturnReplaceFramesOrderDetails({}));

      if (LocationURL !== "/resellcycle-reports") {
        Dispatch(
          getResellcycleReportsList({
            list: [],
            refurbished_brand: [],
            pagination: {},
          })
        );
        Dispatch(
          getResellcycleCustomerReportsList({
            list: [],
            refurbished_brand: [],
            district: [],
            pin_code: [],
            state: [],
            pagination: {},
          })
        );
      } else if (LocationURL !== "/resale-brands") {
        Dispatch(
          getResallBrandList({
            list: [],
            pagination: {},
          })
        );
      } else if (LocationURL !== "/point-list") {
        Dispatch(
          getPointValueList({
            list: [],
            pagination: {},
          })
        );
      }
    };
  }, [LocationURL]);

  const NavigationArrow = (arrow_status) => {
    return (
      <Image
        src={MenuArrow}
        className={arrow_status ? "menu-item-arrow active" : "menu-item-arrow"}
        alt="arrow_menu"
      />
    );
  };

  return (
    <div className="sidebar">
      <CommonScrollBar
        className={""}
        height={{ height: "calc(100vh - 205px)" }}
      >
        {MainNavUrl === "Dashboard" ? (
          <Nav defaultActiveKey={DASHBOARD_URL} className="flex-column">
            <Nav.Link
              className={Object.assign(menuStates)["menu5"] ? "active" : ""}
              onClick={() => toggleMenu("menu5")}
              aria-controls="menu5"
              aria-expanded={menuStates.menu5}
            >
              Dashboard
              {NavigationArrow(Object.assign(menuStates)["menu5"])}
            </Nav.Link>
            <Collapse className="collapnseDrop" in={menuStates.menu5}>
              <div id="menu5">
                <ul>
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Dashboard?.DailyOrdersRGLBangalore ||
                    PermissionsAccess?.Dashboard?.DailyOrdersRGLDelhi ||
                    PermissionsAccess?.Dashboard?.DailyOrdersRGLKolkata ||
                    PermissionsAccess?.Dashboard?.DealerPerformance ||
                    PermissionsAccess?.Dashboard?.OrderFulfillment ||
                    PermissionsAccess?.Dashboard?.SalesRevenueReport ||
                    PermissionsAccess?.Dashboard?.AllOrderSummery) && (
                    <li>
                      <Link
                        className={
                          LocationURL === DASHBOARD_URL ? "active" : ""
                        }
                        to={DASHBOARD_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Dashboard
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.DashboardMain !== undefined) && (
                    <React.Fragment>
                      {(selfInfo?.user?.user_type === "super_admin" ||
                        PermissionsAccess?.DashboardMain[0]?.View) && (
                        <li>
                          <Link
                            className={
                              LocationURL === DASHBOARD_SALES_REVENUE_REPORT_URL
                                ? "active"
                                : ""
                            }
                            to={DASHBOARD_SALES_REVENUE_REPORT_URL}
                            onClick={(e) => CommonNavigationsChange(e)}
                          >
                            Sales Revenue Report
                          </Link>
                        </li>
                      )}
                      {(selfInfo?.user?.user_type === "super_admin" ||
                        PermissionsAccess?.DashboardMain[1]?.View) && (
                        <li>
                          <Link
                            className={
                              LocationURL === DASHBOARD_TRANSACTION_HISTORY_URL
                                ? "active"
                                : ""
                            }
                            to={DASHBOARD_TRANSACTION_HISTORY_URL}
                            onClick={(e) => CommonNavigationsChange(e)}
                          >
                            Ageing Outstanding
                          </Link>
                        </li>
                      )}
                      {(selfInfo?.user?.user_type === "super_admin" ||
                        PermissionsAccess?.DashboardMain[2]?.View) && (
                        <li>
                          <Link
                            className={
                              LocationURL === DASHBOARD_SCHEMES_METRICS_URL ||
                              LocationEditURL === "schemes-metrics"
                                ? "active"
                                : ""
                            }
                            to={DASHBOARD_SCHEMES_METRICS_URL}
                            onClick={(e) => CommonNavigationsChange(e)}
                          >
                            Schemes Metrics
                          </Link>
                        </li>
                      )}
                      {(selfInfo?.user?.user_type === "super_admin" ||
                        PermissionsAccess?.DashboardMain[3]?.View) && (
                        <li>
                          <Link
                            className={
                              LocationURL ===
                              DASHBOARD_WARRANTY_REGISTRATION_URL
                                ? "active"
                                : ""
                            }
                            to={DASHBOARD_WARRANTY_REGISTRATION_URL}
                            onClick={(e) => CommonNavigationsChange(e)}
                          >
                            Warranty Registration Report
                          </Link>
                        </li>
                      )}
                    </React.Fragment>
                  )}
                </ul>
              </div>
            </Collapse>
          </Nav>
        ) : MainNavUrl === "Inventory" ? (
          <Nav defaultActiveKey={DASHBOARD_URL} className="flex-column">
            {(selfInfo?.user?.user_type === "super_admin" ||
              PermissionsAccess?.ProductMasters?.filter(
                (elm) => elm?.API !== "",
              )?.length > 0) && (
              <Nav.Link
                className={Object.assign(menuStates)["menu1"] ? "active" : ""}
                onClick={() => toggleMenu("menu1")}
                aria-controls="menu1"
                aria-expanded={menuStates.menu1}
              >
                Product Masters
                {NavigationArrow(Object.assign(menuStates)["menu1"])}
              </Nav.Link>
            )}
            <Collapse className="collapnseDrop" in={menuStates.menu1}>
              <div id="menu1">
                <ul>
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.ProductMasters[0]?.Edit ||
                    PermissionsAccess?.ProductMasters[0]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PRODUCT_APPLICATIONS_URL ||
                          LocationURL === CREATE_PRODUCT_APLICATION_URL ||
                          LocationEditURL === "edit-product-application"
                            ? "active"
                            : ""
                        }
                        to={PRODUCT_APPLICATIONS_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Product Applications
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.ProductMasters[1]?.Edit ||
                    PermissionsAccess?.ProductMasters[1]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === CATEGORY_URL ||
                          LocationURL === CREATE_CATEGORY_URL ||
                          LocationEditURL === "edit-category"
                            ? "active"
                            : ""
                        }
                        to={CATEGORY_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Category
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.ProductMasters[2]?.Edit ||
                    PermissionsAccess?.ProductMasters[2]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === SUB_CATEGORY_URL ||
                          LocationURL === CREATE_SUB_CATEGORY_URL ||
                          LocationEditURL === "edit-subcategory"
                            ? "active"
                            : ""
                        }
                        to={SUB_CATEGORY_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Sub Category
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.ProductMasters[3]?.Edit ||
                    PermissionsAccess?.ProductMasters[3]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PRODUCT_GROUP_URL ||
                          LocationURL === CREATE_PRODUCT_GROUP_URL ||
                          LocationEditURL === "edit-product-group"
                            ? "active"
                            : ""
                        }
                        to={PRODUCT_GROUP_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Product Group
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.ProductMasters[4]?.Edit ||
                    PermissionsAccess?.ProductMasters[4]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PRODUCT_CREATION_URL ||
                          LocationURL === CREATE_PRODUCT_URL ||
                          LocationEditURL === "edit-product"
                            ? "active"
                            : ""
                        }
                        to={PRODUCT_CREATION_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Product Creation
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.ProductMasters[5]?.Edit ||
                    PermissionsAccess?.ProductMasters[5]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === SPARES_CAMPATIBILITY_URL ||
                          LocationURL === ADD_SPARES_CAMPATIBILITY_URL ||
                          LocationEditURL === "edit-spares-compatibility"
                            ? "active"
                            : ""
                        }
                        to={SPARES_CAMPATIBILITY_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Spares Compatibility
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
            {(selfInfo?.user?.user_type === "super_admin" ||
              PermissionsAccess?.Store?.filter((elm) => elm?.API !== "")
                ?.length > 0) && (
              <Nav.Link
                className={Object.assign(menuStates)["menu2"] ? "active" : ""}
                onClick={() => toggleMenu("menu2")}
                aria-controls="menu2"
                aria-expanded={menuStates.menu2}
              >
                Stores
                {NavigationArrow(Object.assign(menuStates)["menu2"])}
              </Nav.Link>
            )}
            <Collapse className="collapnseDrop" in={menuStates.menu2}>
              <div id="menu2">
                <ul>
                  {/* {(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Store[0]?.Edit || PermissionsAccess?.Store[0]?.View)) && (<li>
                                <NavLink className={LocationURL === STOCK_INWARD_URL ? "active" : ""} to={STOCK_INWARD_URL} onClick={(e) => CommonNavigationsChange(e)}>Stock Inward</NavLink>
                            </li>)}
                            {(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Store[1]?.Edit || PermissionsAccess?.Store[1]?.View)) && (<li>
                                    <Link className={LocationURL === STOCK_LEVEL_URL ? "active" : ""} to={STOCK_LEVEL_URL} onClick={(e) => CommonNavigationsChange(e)}>Stock Level</Link>
                            </li>)}
                            {(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Store[2]?.Edit || PermissionsAccess?.Store[2]?.View)) && (<li>
                                    <Link className={LocationURL === STORE_DETAILS_URL ? "active" : ""} to={STORE_DETAILS_URL} onClick={(e) => CommonNavigationsChange(e)}>Stock Details</Link>
                            </li>)} */}
                  {selfInfo?.user?.user_type === "super_admin" && (
                    <React.Fragment>
                      <li>
                        <NavLink
                          className={
                            LocationURL === STOCK_INWARD_URL ? "active" : ""
                          }
                          to={STOCK_INWARD_URL}
                          onClick={(e) => CommonNavigationsChange(e)}
                        >
                          Stock Inward
                        </NavLink>
                      </li>
                      <li>
                        <Link
                          className={
                            LocationURL === STOCK_LEVEL_URL ? "active" : ""
                          }
                          to={STOCK_LEVEL_URL}
                          onClick={(e) => CommonNavigationsChange(e)}
                        >
                          Stock Level
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={
                            LocationURL === STORE_DETAILS_URL ? "active" : ""
                          }
                          to={STORE_DETAILS_URL}
                          onClick={(e) => CommonNavigationsChange(e)}
                        >
                          Stock Details
                        </Link>
                      </li>
                    </React.Fragment>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Store[3]?.Edit ||
                    PermissionsAccess?.Store[3]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === STORE_INWARD_LOG_URL ? "active" : ""
                        }
                        to={STORE_INWARD_LOG_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Stock Inward Log
                      </Link>
                    </li>
                  )}
                  {/* {(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Store[4]?.Edit || PermissionsAccess?.Store[4]?.View)) && (<li>
                                <Link className={LocationURL === STORE_DETAILS_REPORT_URL ? "active" : ""} to={STORE_DETAILS_REPORT_URL} onClick={(e) => CommonNavigationsChange(e)}>Stock Details Report</Link>
                            </li>)} */}
                  {selfInfo?.user?.user_type === "super_admin" && (
                    <li>
                      <Link
                        className={
                          LocationURL === STORE_DETAILS_REPORT_URL
                            ? "active"
                            : ""
                        }
                        to={STORE_DETAILS_REPORT_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Stock Details Report
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Store[5]?.Edit ||
                    PermissionsAccess?.Store[5]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === ERP_STOCK_LEVEL_URL ? "active" : ""
                        }
                        to={ERP_STOCK_LEVEL_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        ERP Stock Level
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Store[6]?.Edit ||
                    PermissionsAccess?.Store[6]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === ERP_STOCK_REPORT_URL ? "active" : ""
                        }
                        to={ERP_STOCK_REPORT_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        ERP Stock Report
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Store[7]?.Edit ||
                    PermissionsAccess?.Store[7]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === ERP_STOCK_LOGS_URL ? "active" : ""
                        }
                        to={ERP_STOCK_LOGS_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        ERP Stock Logs
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
            {/* {(selfInfo?.user?.user_type === 'super_admin' &&
                    <Nav.Link className={Object.assign(menuStates)["menu3"] ? "active" : ""} onClick={() => toggleMenu('menu3')} aria-controls="menu3" aria-expanded={menuStates.menu3}>
                        <i className="bi bi-arrow-left-right"></i>
                        Stock Transfer
                        <span className={Object.assign(menuStates)["menu3"] ? "bi bi-caret-down-fill" : "bi bi-caret-right-fill"}></span>
                    </Nav.Link>)}
                <Collapse className="collapnseDrop" in={menuStates.menu3}>
                    <div id="menu3">
                        <ul>
                            <li>
                                <Link className={LocationURL === STOCK_TRANSFER_URL ? "active" : ""} to={STOCK_TRANSFER_URL}>Stock Transfer</Link>
                            </li>
                        </ul>
                    </div>
                </Collapse> */}
            {(selfInfo?.user?.user_type === "super_admin" ||
              PermissionsAccess?.Warehouse?.filter((elm) => elm?.API !== "")
                ?.length > 0) && (
              <Nav.Link
                className={Object.assign(menuStates)["menu4"] ? "active" : ""}
                onClick={() => toggleMenu("menu4")}
                aria-controls="menu4"
                aria-expanded={menuStates.menu4}
              >
                Warehouse
                {NavigationArrow(Object.assign(menuStates)["menu4"])}
              </Nav.Link>
            )}
            <Collapse className="collapnseDrop" in={menuStates.menu4}>
              <div id="menu4">
                <ul>
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Warehouse[0]?.Edit ||
                    PermissionsAccess?.Warehouse[0]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === WAREHOUSE_URL ||
                          LocationURL === CREATE_WAREHOUSE_URL ||
                          LocationEditURL === "edit-warehouse"
                            ? "active"
                            : ""
                        }
                        to={WAREHOUSE_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Warehouse
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Warehouse[1]?.Edit ||
                    PermissionsAccess?.Warehouse[1]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === WAREHOUSE_QUICK_URL ? "active" : ""
                        }
                        to={WAREHOUSE_QUICK_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Warehouse Quick Login
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Warehouse[2]?.Edit ||
                    PermissionsAccess?.Warehouse[2]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === DISPATCH_LIST_URL ||
                          LocationURL === CREATE_DISPATCH_LIST_URL ||
                          LocationEditURL === "edit-dispatch"
                            ? "active"
                            : ""
                        }
                        to={DISPATCH_LIST_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Dispatch List
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </Nav>
        ) : MainNavUrl === "Warranty" ? (
          <Nav defaultActiveKey={DASHBOARD_URL} className="flex-column">
            <Nav.Link
              className={Object.assign(menuStates)["menu6"] ? "active" : ""}
              onClick={() => toggleMenu("menu6")}
              aria-controls="menu6"
              aria-expanded={menuStates.menu6}
            >
              Warranty
              {NavigationArrow(Object.assign(menuStates)["menu6"])}
            </Nav.Link>
            <Collapse className="collapnseDrop" in={menuStates.menu6}>
              <div id="menu6">
                <ul>
                  {visibleWarrantyNav(selfInfo).map((item) => (
                    <li key={item.key}>
                      <Link
                        className={
                          item.segments.includes(LocationEditURL) ? "active" : ""
                        }
                        to={item.url}
                        onClick={(e) => WarrantyLinkClick(e)}
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.DashboardMain?.[3]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === DASHBOARD_WARRANTY_REGISTRATION_URL
                            ? "active"
                            : ""
                        }
                        to={DASHBOARD_WARRANTY_REGISTRATION_URL}
                        onClick={(e) => WarrantyLinkClick(e)}
                      >
                        Warranty Registration Report
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </Nav>
        ) : MainNavUrl === "Sales" ? (
          <Nav defaultActiveKey={DASHBOARD_URL} className="flex-column">
            <Nav.Link
              className={Object.assign(menuStates)["menu1"] ? "active" : ""}
              onClick={() => toggleMenu("menu1")}
              aria-controls="menu1"
              aria-expanded={menuStates.menu1}
            >
              Sales Manager
              {NavigationArrow(Object.assign(menuStates)["menu1"])}
            </Nav.Link>
            <Collapse className="collapnseDrop" in={menuStates.menu1}>
              <div id="menu1">
                <ul>
                  <li>
                    <a href="#">All Orders Report</a>
                  </li>
                  <li>
                    <a href="#">Draft Orders Report</a>
                  </li>
                  <li>
                    <a href="#">Pending For Accounts</a>
                  </li>
                  <li>
                    <a href="#">Pending For Stores</a>
                  </li>
                  <li>
                    <a href="#">Pending For Dispatch</a>
                  </li>
                  <li>
                    <a href="#">Pending For Delivery</a>
                  </li>
                  <li>
                    <a href="#">Delivered</a>
                  </li>
                  <li>
                    <a href="#">Rejected</a>
                  </li>
                  <li>
                    <a href="#">EInvoiceOnline Details</a>
                  </li>
                  <li>
                    <a href="#">E-Invoice Cancel</a>
                  </li>
                  <li>
                    <a href="#">Other Payments Report</a>
                  </li>
                </ul>
              </div>
            </Collapse>
            <Nav.Link
              className={Object.assign(menuStates)["menu2"] ? "active" : ""}
              onClick={() => toggleMenu("menu2")}
              aria-controls="menu2"
              aria-expanded={menuStates.menu2}
            >
              MasterShoppee
              {NavigationArrow(Object.assign(menuStates)["menu2"])}
            </Nav.Link>
            <Collapse className="collapnseDrop" in={menuStates.menu2}>
              <div id="menu2">
                <ul>
                  <li>
                    <a href="#">Shop Now</a>
                  </li>
                </ul>
              </div>
            </Collapse>
            <Nav.Link
              className={Object.assign(menuStates)["menu3"] ? "active" : ""}
              onClick={() => toggleMenu("menu3")}
              aria-controls="menu3"
              aria-expanded={menuStates.menu3}
            >
              Reports
              {NavigationArrow(Object.assign(menuStates)["menu3"])}
            </Nav.Link>
            <Collapse className="collapnseDrop" in={menuStates.menu3}>
              <div id="menu3">
                <ul>
                  <li>
                    <Link
                      className={
                        LocationURL === OUT_STANDING_DATA_REPORT ? "active" : ""
                      }
                      to={OUT_STANDING_DATA_REPORT}
                      onClick={(e) => CommonNavigationsChange(e)}
                    >
                      Out-Standing Report
                    </Link>
                  </li>
                  <li>
                    <a href="#">QR Purchase Report</a>
                  </li>
                  <li>
                    <a href="#">DSR Monthly Report</a>
                  </li>
                  <li>
                    <a href="#">DSR Product Wise Report</a>
                  </li>
                  <li>
                    <a href="#">Update QR Purchase</a>
                  </li>
                  <li>
                    <a href="#">Frame Number Update</a>
                  </li>
                </ul>
              </div>
            </Collapse>
          </Nav>
        ) : MainNavUrl === "Admin-Tools" ? (
          <Nav defaultActiveKey={DASHBOARD_URL} className="flex-column">
            {(selfInfo?.user?.user_type === "super_admin" ||
              PermissionsAccess?.AdminTools?.filter((elm) => elm?.API !== "")
                ?.length > 0) && (
              <Nav.Link
                className={Object.assign(menuStates)["menu1"] ? "active" : ""}
                onClick={() => toggleMenu("menu1")}
                aria-controls="menu1"
                aria-expanded={menuStates.menu1}
              >
                Admin Tools
                {NavigationArrow(Object.assign(menuStates)["menu1"])}
              </Nav.Link>
            )}
            <Collapse className="collapnseDrop" in={menuStates.menu1}>
              <div id="menu1">
                <ul>
                  <li>
                    {(selfInfo?.user?.user_type === "super_admin" ||
                      PermissionsAccess?.AdminTools[0]?.Edit ||
                      PermissionsAccess?.AdminTools[0]?.View) && (
                      <li>
                        <Link
                          className={
                            LocationURL === USER_MANAGEMENT_URL ||
                            LocationURL === CREATE_USER_MANAGEMENT_URL ||
                            LocationEditURL === "edit-user"
                              ? "active"
                              : ""
                          }
                          to={USER_MANAGEMENT_URL}
                          onClick={(e) => CommonNavigationsChange(e)}
                        >
                          Users
                        </Link>
                      </li>
                    )}
                    {(selfInfo?.user?.user_type === "super_admin" ||
                      PermissionsAccess?.AdminTools[1]?.Edit ||
                      PermissionsAccess?.AdminTools[1]?.View) && (
                      <li>
                        <Link
                          className={
                            LocationURL === FRANCHISE_USER_REPORT_URL ||
                            LocationURL === CREATE_FRANCHISE_USER_REPORT_URL ||
                            LocationEditURL === "edit-franchise-user-report"
                              ? "active"
                              : ""
                          }
                          to={FRANCHISE_USER_REPORT_URL}
                          onClick={(e) => CommonNavigationsChange(e)}
                        >
                          Create Franchise
                        </Link>
                      </li>
                    )}
                    {(selfInfo?.user?.user_type === "super_admin" ||
                      PermissionsAccess?.AdminTools[2]?.Edit ||
                      PermissionsAccess?.AdminTools[2]?.View) && (
                      <li>
                        <Link
                          className={
                            LocationURL === FRANCHISE_TYPE_REPORT_URL ||
                            LocationURL === ADD_FRANCHISE_TYPE_REPORT_URL ||
                            LocationEditURL === "edit-franchise-type-report"
                              ? "active"
                              : ""
                          }
                          to={FRANCHISE_TYPE_REPORT_URL}
                          onClick={(e) => CommonNavigationsChange(e)}
                        >
                          Franchise Type
                        </Link>
                      </li>
                    )}
                    {(selfInfo?.user?.user_type === "super_admin" ||
                      PermissionsAccess?.AdminTools[3]?.Edit ||
                      PermissionsAccess?.AdminTools[3]?.View) && (
                      <li>
                        <Link
                          className={
                            LocationURL === RM_LOGIN_URL ? "active" : ""
                          }
                          to={RM_LOGIN_URL}
                          onClick={(e) => CommonNavigationsChange(e)}
                        >
                          Regional Manager Login
                        </Link>
                      </li>
                    )}
                  </li>
                </ul>
              </div>
            </Collapse>
            {(selfInfo?.user?.user_type === "super_admin" ||
              PermissionsAccess?.Masters?.filter((elm) => elm?.API !== "")
                ?.length > 0) && (
              <Nav.Link
                className={Object.assign(menuStates)["menu2"] ? "active" : ""}
                onClick={() => toggleMenu("menu2")}
                aria-controls="menu2"
                aria-expanded={menuStates.menu2}
              >
                Masters
                {NavigationArrow(Object.assign(menuStates)["menu2"])}
              </Nav.Link>
            )}
            <Collapse className="collapnseDrop" in={menuStates.menu2}>
              <div id="menu2">
                <ul>
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Masters[0]?.Edit ||
                    PermissionsAccess?.Masters[0]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === STATES_URL ||
                          LocationURL === ADD_STATES_URL ||
                          LocationEditURL === "edit-state"
                            ? "active"
                            : ""
                        }
                        to={STATES_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        States
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Masters[1]?.Edit ||
                    PermissionsAccess?.Masters[1]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === CITIES_URL ||
                          LocationURL === ADD_CITIES_URL ||
                          LocationEditURL === "edit-cities"
                            ? "active"
                            : ""
                        }
                        to={CITIES_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Cities
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Masters[2]?.Edit ||
                    PermissionsAccess?.Masters[2]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PINE_CODES_URL ||
                          LocationURL === ADD_PINCODES_URL ||
                          LocationEditURL === "edit-pincode"
                            ? "active"
                            : ""
                        }
                        to={PINE_CODES_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Pincodes
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Masters[3]?.Edit ||
                    PermissionsAccess?.Masters[3]?.View) && (
                    <li>
                      <Link
                        className={LocationURL === BOX_URL ? "active" : ""}
                        to={BOX_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Box
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.Masters[4]?.Edit ||
                    PermissionsAccess?.Masters[4]?.View) && (
                    <li>
                      <NavLink
                        to={COURIERS_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Couriers
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </Nav>
        ) : MainNavUrl === "Franchise" ? (
          <Nav defaultActiveKey={DASHBOARD_URL} className="flex-column">
            {(selfInfo?.user?.user_type === "super_admin" ||
              hasD2cOpsAccess(selfInfo) ||
              PermissionsAccess?.OrderManagement?.filter(
                (elm) => elm?.API !== "",
              )?.length > 0) && (
              <Nav.Link
                className={Object.assign(menuStates)["menu1"] ? "active" : ""}
                onClick={() => toggleMenu("menu1")}
                aria-controls="menu1"
                aria-expanded={menuStates.menu1}
              >
                Order Management
                {NavigationArrow(Object.assign(menuStates)["menu1"])}
              </Nav.Link>
            )}
            <Collapse className="collapnseDrop" in={menuStates.menu1}>
              <div id="menu1">
                <ul>
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[0]?.Edit ||
                    PermissionsAccess?.OrderManagement[0]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === FRANCHISE_ORDERSREPORT_URL
                            ? "active"
                            : ""
                        }
                        to={FRANCHISE_ORDERSREPORT_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        All Orders Report
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[1]?.Edit ||
                    PermissionsAccess?.OrderManagement[1]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PURCHASE_ORDER_URL ? "active" : ""
                        }
                        to={PURCHASE_ORDER_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        SO Creation
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[20]?.Edit ||
                    PermissionsAccess?.OrderManagement[20]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === FRANCHISE_DRAFT_ORDERSREPORT_URL
                            ? "active"
                            : ""
                        }
                        to={FRANCHISE_DRAFT_ORDERSREPORT_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Draft Orders Report
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[2]?.Edit ||
                    PermissionsAccess?.OrderManagement[2]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PO_POSTING_URL ||
                          LocationEditURL === "so-approval"
                            ? "active"
                            : ""
                        }
                        to={PO_POSTING_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        SO Approvals
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[3]?.Edit ||
                    PermissionsAccess?.OrderManagement[3]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PO_APPROVALS_URL ||
                          LocationEditURL === "warehouse-approvals"
                            ? "active"
                            : ""
                        }
                        to={PO_APPROVALS_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Warehouse Approval
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[5]?.Edit ||
                    PermissionsAccess?.OrderManagement[5]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === FRANCHISE_DISPATCH_URL ||
                          LocationEditURL === "pending-for-stores"
                            ? "active"
                            : ""
                        }
                        to={FRANCHISE_DISPATCH_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Pending For Stores
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[6]?.Edit ||
                    PermissionsAccess?.OrderManagement[6]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === FRANCHISE_DISPATCH_PENDING_URL ||
                          LocationEditURL === "pending-for-dispatch"
                            ? "active"
                            : ""
                        }
                        to={FRANCHISE_DISPATCH_PENDING_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Pending For Dispatch
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[7]?.Edit ||
                    PermissionsAccess?.OrderManagement[7]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === FRANCHISE_PENDING_DELIVERY_URL ||
                          LocationEditURL === "pending-for-delivery"
                            ? "active"
                            : ""
                        }
                        to={FRANCHISE_PENDING_DELIVERY_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Pending For Delivery
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[8]?.Edit ||
                    PermissionsAccess?.OrderManagement[8]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PUR_ORDER_DELIVERED_URL
                            ? "active"
                            : ""
                        }
                        to={PUR_ORDER_DELIVERED_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Order Delivered
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[9]?.Edit ||
                    PermissionsAccess?.OrderManagement[9]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PUR_INVOICE_DETAILS_URL
                            ? "active"
                            : ""
                        }
                        to={PUR_INVOICE_DETAILS_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Rejected
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[10]?.Edit ||
                    PermissionsAccess?.OrderManagement[10]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === ORDER_CANCELLED_URL ? "active" : ""
                        }
                        to={ORDER_CANCELLED_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Cancellation
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[11]?.Edit ||
                    PermissionsAccess?.OrderManagement[11]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === E_INVOICE_DETAILS_URL ? "active" : ""
                        }
                        to={E_INVOICE_DETAILS_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        E-Invoice Details
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[12]?.Edit ||
                    PermissionsAccess?.OrderManagement[12]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === E_INVOICE_CANCEL_URL ? "active" : ""
                        }
                        to={E_INVOICE_CANCEL_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        E-Invoice Cancel
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[13]?.Edit ||
                    PermissionsAccess?.OrderManagement[13]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === E_WAY_BILL_URL ? "active" : ""
                        }
                        to={E_WAY_BILL_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        E-Way Bill
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[14]?.Edit ||
                    PermissionsAccess?.OrderManagement[14]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === RETURN_AND_REPLACE_REPORT_LIST ||
                          LocationURL === RETURN_AND_REPLACE_REPORT
                            ? "active"
                            : ""
                        }
                        to={RETURN_AND_REPLACE_REPORT_LIST}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Return And Replace
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[15]?.Edit ||
                    PermissionsAccess?.OrderManagement[15]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === ERP_API_FAILURES_LIST ? "active" : ""
                        }
                        to={ERP_API_FAILURES_LIST}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        {/* Erp Api Failures */}
                        ERP Order Sync
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[16]?.Edit ||
                    PermissionsAccess?.OrderManagement[16]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === FBA_ORDER_LIST ||
                          LocationEditURL === "fba-orders-details"
                            ? "active"
                            : ""
                        }
                        to={FBA_ORDER_LIST}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        FBA Orders
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[17]?.Edit ||
                    PermissionsAccess?.OrderManagement[17]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === RE_ASSIGN_WAREHOUSE_LIST
                            ? "active"
                            : ""
                        }
                        to={RE_ASSIGN_WAREHOUSE_LIST}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Re-Assign Warehouse
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[18]?.Edit ||
                    PermissionsAccess?.OrderManagement[18]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === UNICOMMERCE_API_FAILURES_REPORT
                            ? "active"
                            : ""
                        }
                        to={UNICOMMERCE_API_FAILURES_REPORT}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        {/* Unicommerce Api Failures */}
                        Unicommerce Order Sync
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.OrderManagement[19]?.Edit ||
                    PermissionsAccess?.OrderManagement[19]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === UPCOMING_ORDER_URL ? "active" : ""
                        }
                        to={UPCOMING_ORDER_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Upcoming Orders
                      </Link>
                    </li>
                  )}
                  {hasD2cOpsAccess(selfInfo) && (
                    <li>
                      <Link
                        className={
                          LocationURL === D2C_DASHBOARD_URL ? "active" : ""
                        }
                        to={D2C_DASHBOARD_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        D2C Dashboard
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>

            {(selfInfo?.user?.user_type === "super_admin" ||
              PermissionsAccess?.AFSOrderManagement !== undefined) && (
              <>
                {(selfInfo?.user?.user_type === "super_admin" ||
                  PermissionsAccess?.AFSOrderManagement?.filter(
                    (elz) => elz?.label !== "AFS Order Sync",
                  )?.filter((elm) => elm?.API !== "")?.length > 0) && (
                  <Nav.Link
                    className={
                      Object.assign(menuStates)["menu3"] ? "active" : ""
                    }
                    onClick={() => toggleMenu("menu3")}
                    aria-controls="menu3"
                    aria-expanded={menuStates.menu3}
                  >
                    AFS Order Management
                    {NavigationArrow(Object.assign(menuStates)["menu3"])}
                  </Nav.Link>
                )}
                <Collapse className="collapnseDrop" in={menuStates.menu3}>
                  <div id="menu3">
                    <ul>
                      {(selfInfo?.user?.user_type === "super_admin" ||
                        PermissionsAccess?.AFSOrderManagement[0]?.Edit ||
                        PermissionsAccess?.AFSOrderManagement[0]?.View) && (
                        <li>
                          <Link
                            className={
                              LocationURL === AFTER_SALES_ORDERS_URL ||
                              LocationEditURL === "after-sales-orders"
                                ? "active"
                                : ""
                            }
                            to={AFTER_SALES_ORDERS_URL}
                            onClick={(e) => CommonNavigationsChange(e)}
                          >
                            After Sales Orders
                          </Link>
                        </li>
                      )}
                      {(selfInfo?.user?.user_type === "super_admin" ||
                        PermissionsAccess?.AFSOrderManagement[1]?.Edit ||
                        PermissionsAccess?.AFSOrderManagement[1]?.View) && (
                        <li>
                          <Link
                            className={
                              LocationURL === AFS_PURCHASE_ORDER_URL
                                ? "active"
                                : ""
                            }
                            to={AFS_PURCHASE_ORDER_URL}
                            onClick={(e) => CommonNavigationsChange(e)}
                          >
                            SO Creation ( AFS )
                          </Link>
                        </li>
                      )}
                      {(selfInfo?.user?.user_type === "super_admin" ||
                        PermissionsAccess?.AFSOrderManagement[2]?.Edit ||
                        PermissionsAccess?.AFSOrderManagement[2]?.View) && (
                        <li>
                          <Link
                            className={
                              LocationURL === QUOTATION_REPORT_URL ||
                              LocationEditURL === "quotation-details"
                                ? "active"
                                : ""
                            }
                            to={QUOTATION_REPORT_URL}
                            onClick={(e) => CommonNavigationsChange(e)}
                          >
                            Quotation Report
                          </Link>
                        </li>
                      )}
                      {(selfInfo?.user?.user_type === "super_admin" ||
                        PermissionsAccess?.AFSOrderManagement[3]?.Edit ||
                        PermissionsAccess?.AFSOrderManagement[3]?.View) && (
                        <li>
                          <Link
                            className={
                              LocationURL === AFS_ORDER_SYNC_REPORT_URL
                                ? "active"
                                : ""
                            }
                            to={AFS_ORDER_SYNC_REPORT_URL}
                            onClick={(e) => CommonNavigationsChange(e)}
                          >
                            AFS Order Sync
                          </Link>
                        </li>
                      )}
                      {(selfInfo?.user?.user_type === "super_admin" ||
                        PermissionsAccess?.AFSOrderManagement[4]?.Edit ||
                        PermissionsAccess?.AFSOrderManagement[4]?.View) && (
                        <li>
                          <Link
                            className={
                              LocationURL === QUOTATION_CREATIONS_URL
                                ? "active"
                                : ""
                            }
                            to={QUOTATION_CREATIONS_URL}
                            onClick={(e) => CommonNavigationsChange(e)}
                          >
                            Quotation Creation
                          </Link>
                        </li>
                      )}

                      {(selfInfo?.user?.user_type === "super_admin" ||
                        PermissionsAccess?.AFSOrderManagement[5]?.Edit ||
                        PermissionsAccess?.AFSOrderManagement[5]?.View) && (
                        <li>
                          <Link
                            className={
                              LocationURL ===
                                PAYMENT_APPROVAL_PENDING_QUOTATION_URL ||
                              LocationEditURL ===
                                "payment-approval-quotation-details"
                                ? "active"
                                : ""
                            }
                            to={PAYMENT_APPROVAL_PENDING_QUOTATION_URL}
                            onClick={(e) => CommonNavigationsChange(e)}
                          >
                            Payment Approval Pending
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </Collapse>
              </>
            )}

            {(selfInfo?.user?.user_type === "super_admin" ||
              PermissionsAccess?.PaymentManager?.filter(
                (elm) => elm?.API !== undefined,
              )?.filter((elm) => elm?.API !== "")?.length > 0) && (
              <Nav.Link
                className={Object.assign(menuStates)["menu2"] ? "active" : ""}
                onClick={() => toggleMenu("menu2")}
                aria-controls="menu2"
                aria-expanded={menuStates.menu2}
              >
                Payment Manager
                {NavigationArrow(Object.assign(menuStates)["menu2"])}
              </Nav.Link>
            )}
            <Collapse className="collapnseDrop" in={menuStates.menu2}>
              <div id="menu2">
                <ul>
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.PaymentManager[0]?.Edit ||
                    PermissionsAccess?.PaymentManager[0]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === ACCOUNT_LEDGER_REPORT ? "active" : ""
                        }
                        to={ACCOUNT_LEDGER_REPORT}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Account Ledger Report
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.PaymentManager[1]?.Edit ||
                    PermissionsAccess?.PaymentManager[1]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === DEBIT_CREDIT_NOTES ||
                          LocationEditURL === "debit-credit-notes"
                            ? "active"
                            : ""
                        }
                        to={DEBIT_CREDIT_NOTES}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Debit/Credit Notes
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.PaymentManager[2]?.Edit ||
                    PermissionsAccess?.PaymentManager[2]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === DEBIT_CREDIT_NOTE_REPORT
                            ? "active"
                            : ""
                        }
                        to={DEBIT_CREDIT_NOTE_REPORT}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Debit/Credit Note Report
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.PaymentManager[3]?.Edit ||
                    PermissionsAccess?.PaymentManager[3]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PAYMENT_APPROVAL ? "active" : ""
                        }
                        to={PAYMENT_APPROVAL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Payment Approval
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.PaymentManager[4]?.Edit ||
                    PermissionsAccess?.PaymentManager[4]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === GST_DATA_REPORT ? "active" : ""
                        }
                        to={GST_DATA_REPORT}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        GST Data Report
                      </Link>
                    </li>
                  )}
                  {/* {(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.PaymentManager[5]?.Edit || PermissionsAccess?.PaymentManager[5]?.View)) && (
                                <li><Link className={LocationURL === ERP_OUTSTANDING_REPORT ? "active" : ""} to={ERP_OUTSTANDING_REPORT} onClick={(e) => CommonNavigationsChange(e)}>ERP Outstanding Report</Link></li>
                            )} */}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.PaymentManager[6]?.Edit ||
                    PermissionsAccess?.PaymentManager[6]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === ERP_GENERAL_OUTSTANDING_REPORT
                            ? "active"
                            : ""
                        }
                        to={ERP_GENERAL_OUTSTANDING_REPORT}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        ERP General Outstanding Report
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.PaymentManager[7]?.Edit ||
                    PermissionsAccess?.PaymentManager[7]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PAYMENT_APPROVAL_URL ? "active" : ""
                        }
                        to={PAYMENT_APPROVAL_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Dealer Payment Approval
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.PaymentManager[8]?.Edit ||
                    PermissionsAccess?.PaymentManager[8]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === FRANCHISE_REPORTS_URL ? "active" : ""
                        }
                        to={FRANCHISE_REPORTS_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Franchise Reports
                      </Link>
                    </li>
                  )}
                  {/* {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.PaymentManager[9]?.Edit ||
                    PermissionsAccess?.PaymentManager[9]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === ORDER_PAYMENT_APPROVAL_PENDING
                            ? "active"
                            : ""
                        }
                        to={ORDER_PAYMENT_APPROVAL_PENDING}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Website Payment Approval
                      </Link>
                    </li>
                  )} */}
                </ul>
              </div>
            </Collapse>
          </Nav>
        ) : (
          <Nav defaultActiveKey={DASHBOARD_URL} className="flex-column">
            {(selfInfo?.user?.user_type === "super_admin" ||
              PermissionsAccess?.CRMTools?.filter((elm) => elm?.API !== "")
                ?.length > 0) && (
              <Nav.Link
                className={Object.assign(menuStates)["menu1"] ? "active" : ""}
                onClick={() => toggleMenu("menu1")}
                aria-controls="menu1"
                aria-expanded={menuStates.menu1}
              >
                CRM
                {NavigationArrow(Object.assign(menuStates)["menu1"])}
              </Nav.Link>
            )}
            <Collapse className="collapnseDrop" in={menuStates.menu1}>
              <div id="menu1">
                <ul>
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.CRMTools[0]?.Edit ||
                    PermissionsAccess?.CRMTools[0]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === REGION_MASTER_URL ||
                          LocationURL === ADD_REGION_MASTER_URL ||
                          LocationEditURL === "edit-region-master"
                            ? "active"
                            : ""
                        }
                        to={REGION_MASTER_URL}
                      >
                        Region Master
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.CRMTools[1]?.Edit ||
                    PermissionsAccess?.CRMTools[1]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PURCHASE_LIST_URL ||
                          LocationEditURL === "edit-purchase"
                            ? "active"
                            : ""
                        }
                        to={PURCHASE_LIST_URL}
                      >
                        Purchase List
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.CRMTools[3]?.Edit ||
                    PermissionsAccess?.CRMTools[3]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === PURCHASE_LOG_LIST_URL ? "active" : ""
                        }
                        to={PURCHASE_LOG_LIST_URL}
                      >
                        Purchase Log List
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.CRMTools[2]?.Edit ||
                    PermissionsAccess?.CRMTools[2]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === SALES_PERSON_PERFORMANCE_URL ||
                          LocationURL === ADD_SALES_PERSON_PERFORMANCE_URL
                            ? "active"
                            : ""
                        }
                        to={SALES_PERSON_PERFORMANCE_URL}
                      >
                        Sales Person Performance
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.CRMTools[4]?.Edit ||
                    PermissionsAccess?.CRMTools[4]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === ALL_MAIL_LISTING_URL ||
                          LocationEditURL === "create-mails" ||
                          LocationEditURL === "update-mails"
                            ? "active"
                            : ""
                        }
                        to={ALL_MAIL_LISTING_URL}
                      >
                        All Mail Listing
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
            {(selfInfo?.user?.user_type === "super_admin" ||
              PermissionsAccess?.ReSells?.filter((elm) => elm?.API !== "")
                ?.length > 0) && (
              <Nav.Link
                className={Object.assign(menuStates)["menu2"] ? "active" : ""}
                onClick={() => toggleMenu("menu2")}
                aria-controls="menu1"
                aria-expanded={menuStates.menu1}
              >
                Re-Sale
                {NavigationArrow(Object.assign(menuStates)["menu2"])}
              </Nav.Link>
            )}
            <Collapse className="collapnseDrop" in={menuStates.menu2}>
              <div id="menu2">
                <ul>
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.ReSells[0]?.Edit ||
                    PermissionsAccess?.ReSells[0]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === REFURBISHED_REPORT_LIST
                            ? "active"
                            : ""
                        }
                        to={REFURBISHED_REPORT_LIST}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Resellcycle Reports
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.ReSells[1]?.Edit ||
                    PermissionsAccess?.ReSells[1]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === RESALE_BRANDS_URL ||
                          LocationURL === ADD_RESALE_BRANDS_URL ||
                          LocationEditURL === "edit-resale-brand"
                            ? "active"
                            : ""
                        }
                        to={RESALE_BRANDS_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Re-sele Brands
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.ReSells[2]?.Edit ||
                    PermissionsAccess?.ReSells[2]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === SETTINGS_REFURBISHED_REPORT
                            ? "active"
                            : ""
                        }
                        to={SETTINGS_REFURBISHED_REPORT}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Settings
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.ReSells[3]?.Edit ||
                    PermissionsAccess?.ReSells[3]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === AGE_VALUE_REPORT ||
                          LocationURL === ADD_AGE_VALUE_REPORT ||
                          LocationEditURL === "edit-age-value"
                            ? "active"
                            : ""
                        }
                        to={AGE_VALUE_REPORT}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Age Value
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    PermissionsAccess?.ReSells[4]?.Edit ||
                    PermissionsAccess?.ReSells[4]?.View) && (
                    <li>
                      <Link
                        className={
                          LocationURL === POINT_VALUE_REFURBISHED_REPORT ||
                          LocationURL === ADD_POINT_VALUE_REFURBISHED_REPORT ||
                          LocationEditURL === "edit-point" ||
                          LocationURL === ADD_POINT_VALUE_SETTINGS ||
                          LocationEditURL === "edit-point-settings"
                            ? "active"
                            : ""
                        }
                        to={POINT_VALUE_REFURBISHED_REPORT}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Point List
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>

            {(selfInfo?.user?.user_type === "super_admin" ||
              PermissionsAccess?.DealerApp?.filter(
                (elm) => elm?.API !== "" && elm?.API !== undefined,
              )?.length > 0) && (
              <Nav.Link
                className={Object.assign(menuStates)["menu3"] ? "active" : ""}
                onClick={() => toggleMenu("menu3")}
                aria-controls="menu1"
                aria-expanded={menuStates.menu3}
              >
                Dealer App
                {NavigationArrow(Object.assign(menuStates)["menu3"])}
              </Nav.Link>
            )}
            <Collapse className="collapnseDrop" in={menuStates.menu3}>
              <div id="menu3">
                <ul>
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[0]?.Edit) ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[0]?.View)) && (
                    <li>
                      <Link
                        className={
                          LocationURL === INCENTIVE_SLAB_URL ||
                          LocationURL === ADD_INCENTIVE_SLAB_URL ||
                          LocationEditURL === "edit-incentive-slab"
                            ? "active"
                            : ""
                        }
                        to={INCENTIVE_SLAB_URL}
                      >
                        Incentive Slab
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[1]?.Edit) ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[1]?.View)) && (
                    <li>
                      <Link
                        className={
                          LocationURL === SCHEMES_URL ||
                          LocationURL === ADD_SCHEMES_URL ||
                          LocationEditURL === "edit-schemes"
                            ? "active"
                            : ""
                        }
                        to={SCHEMES_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Schemes
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[2]?.Edit) ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[2]?.View)) && (
                    <li>
                      <Link
                        className={LocationURL === TICKETS_URL ? "active" : ""}
                        to={TICKETS_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Tickets
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[3]?.Edit) ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[3]?.View)) && (
                    <li>
                      <Link
                        className={
                          LocationURL === HELP_DESK_CATEGORY ||
                          LocationURL === ADD_HELP_DESK_CATEGORY ||
                          LocationEditURL === "edit-help-desk-category"
                            ? "active"
                            : ""
                        }
                        to={HELP_DESK_CATEGORY}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Help Desk Category
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[4]?.Edit) ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[4]?.View)) && (
                    <li>
                      <Link
                        className={
                          LocationURL === HELP_DESK_SUB_CATEGORY ||
                          LocationURL === ADD_HELP_DESK_SUB_CATEGORY ||
                          LocationEditURL === "edit-help-desk-sub-category"
                            ? "active"
                            : ""
                        }
                        to={HELP_DESK_SUB_CATEGORY}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Help Desk Sub Category
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[5]?.Edit) ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[5]?.View)) && (
                    <li>
                      <Link
                        className={
                          LocationURL === HELP_DESK_FAQ ||
                          LocationURL === ADD_HELP_DESK_FAQ ||
                          LocationEditURL === "edit-help-desk-faq"
                            ? "active"
                            : ""
                        }
                        to={HELP_DESK_FAQ}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Help Desk FAQ
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[6]?.Edit) ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[6]?.View)) && (
                    <li>
                      <Link
                        className={
                          LocationURL === NOTIFICATION_AND_CMS_URL ||
                          LocationEditURL === "create-notifications-and-cms" ||
                          LocationEditURL === "edit-notifications-and-cms"
                            ? "active"
                            : ""
                        }
                        to={NOTIFICATION_AND_CMS_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Notification & CMS
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[7]?.Edit) ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[7]?.View)) && (
                    <li>
                      <Link
                        className={
                          LocationURL === MARKETING_CAMPAIGNS_URL ||
                          LocationEditURL === "create-marketing-campaigns" ||
                          LocationEditURL === "edit-marketing-campaigns"
                            ? "active"
                            : ""
                        }
                        to={MARKETING_CAMPAIGNS_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Marketing Campaigns
                      </Link>
                    </li>
                  )}
                  {(selfInfo?.user?.user_type === "super_admin" ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[7]?.Edit) ||
                    (PermissionsAccess?.DealerApp &&
                      PermissionsAccess?.DealerApp[7]?.View)) && (
                    <li>
                      <Link
                        className={
                          LocationURL === OFFER_SCHEME_URL ||
                          LocationEditURL === "create-offer-scheme" ||
                          LocationEditURL === "edit-offer-scheme"
                            ? "active"
                            : ""
                        }
                        to={OFFER_SCHEME_URL}
                        onClick={(e) => CommonNavigationsChange(e)}
                      >
                        Offer & Schemes
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </Nav>
        )}
      </CommonScrollBar>
    </div>
  );
};

export default SidebarChild;
